module.exports = __webpack_public_path__ + "93892c24ddfd0cada83479657e352ec5.svg";